import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import styles from "./Portal.module.css";
import NavigationBar from "../../components/navbar/NavigationBar";
import Dashboard from "./Dashboard/Dashboard";
import AppRegistration from "./AppRegistration/AppRegistration";
import Settings from "./Settings/Settings";

function Portal() {
    return (
        <div className={styles["portal-container"]}>
            <NavigationBar isPortal={true} />
            <div className={styles["portal-content"]}>
                <Routes>
                    <Route path="/" element={<Navigate to="/portal/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/apps" element={<AppRegistration />} />
                    <Route path="/settings" element={<Settings />} />
                </Routes>
            </div>
        </div>
    )
}

export default Portal;